import React, { useContext } from "react";
import { Account } from "@bn/api/apiv1";
import { useAccountIdsByTypes } from "@api";
import { useSelectGroupsForId } from "../../hooks/useSelectGroupsForId.ts";
import {
  DashboardSelectedGroupsContext,
  DashboardSelectedGroupsContextProps,
} from "./DashboardSelectedGroupsContext";

export const useDashboardSelectedGroupsContext =
  (): DashboardSelectedGroupsContextProps => {
    const context = useContext(DashboardSelectedGroupsContext);
    if (!context) {
      throw new Error(
        "useDashboardSelectedGroups must be used within a DashboardSelectedGroupsProvider"
      );
    }
    return context;
  };

export const DashboardSelectedGroupsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const {
    data: selectedGroup,
    selectedAccounts,
    refetch: refetchGroups,
    isFetching,
    isPending,
  } = useSelectGroupsForId({
    id: "dashboard",
  });

  const groupedAccountIds = useAccountIdsByTypes(selectedAccounts as Account[]);

  return (
    <DashboardSelectedGroupsContext.Provider
      value={{
        accountIds: selectedGroup?.accountIds,
        selectedGroup: selectedGroup,
        groupedAccountIds,
        accounts: selectedAccounts as Account[],
        refetch: refetchGroups,
        isFetching,
        isPending,
      }}
    >
      {children}
    </DashboardSelectedGroupsContext.Provider>
  );
};
